/* Performance Analytics — Dashboard Catalog (search/filter over the manifest).
 * Ported from the (8) design: filter all dashboards by category / role /
 * department / tag, star to pin to My Dashboards, click a card to open it. */
import { useState } from 'react';
import { PAGE_MANIFEST, ROLE_DEFS, roleLabel } from './manifest';

interface Props {
  onOpen: (id: string, label: string) => void;
}

export function Catalog({ onOpen }: Props) {
  const [q, setQ] = useState('');
  const [category, setCategory] = useState('');
  const [role, setRole] = useState('');
  const [dept, setDept] = useState('');
  const [tag, setTag] = useState('');

  const categories = [...new Set(PAGE_MANIFEST.map((p) => p.category))];
  const depts = [...new Set(PAGE_MANIFEST.map((p) => p.dept))];
  const tags = [...new Set(PAGE_MANIFEST.flatMap((p) => p.tags))].sort();

  const filtered = PAGE_MANIFEST.filter((p) =>
    (!q || p.label.toLowerCase().includes(q.toLowerCase())) &&
    (!category || p.category === category) &&
    (!role || p.role.includes(role)) &&
    (!dept || p.dept === dept) &&
    (!tag || p.tags.includes(tag)),
  );
  const anyFilter = !!(q || category || role || dept || tag);

  return (
    <>
      <div className="pa-page-title">Dashboard Catalog</div>
      <div className="pa-page-desc">Search and filter across all {PAGE_MANIFEST.length} dashboards by category, role, department, or tag.</div>
      <div className="pa-catalog-filters">
        <input type="text" placeholder="Search dashboards…" value={q} onChange={(e) => setQ(e.target.value)} />
        <select value={category} onChange={(e) => setCategory(e.target.value)}><option value="">All Categories</option>{categories.map((c) => <option key={c} value={c}>{c}</option>)}</select>
        <select value={role} onChange={(e) => setRole(e.target.value)}><option value="">All Roles</option>{ROLE_DEFS.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}</select>
        <select value={dept} onChange={(e) => setDept(e.target.value)}><option value="">All Departments</option>{depts.map((d) => <option key={d} value={d}>{d}</option>)}</select>
        <select value={tag} onChange={(e) => setTag(e.target.value)}><option value="">All Tags</option>{tags.map((t) => <option key={t} value={t}>{t}</option>)}</select>
        {anyFilter && <button className="ca-btn" onClick={() => { setQ(''); setCategory(''); setRole(''); setDept(''); setTag(''); }}>Clear filters</button>}
      </div>
      <div className="pa-catalog-count">{filtered.length} dashboard{filtered.length !== 1 ? 's' : ''}</div>
      <div className="pa-catalog-grid">
        {filtered.map((p) => (
          <div className="pa-catalog-card" key={p.id} onClick={() => onOpen(p.id, p.label)}>
            <div className="pa-catalog-card-top">
              <i className={`ti ${p.icon}`} />
            </div>
            <div className="pa-catalog-card-label">{p.label}{p.badge && <span className={`pa-badge ${p.badge}`}>{p.badge === 'ai' ? 'AI' : 'New'}</span>}</div>
            <div className="pa-catalog-card-meta">{p.category}</div>
            <div className="pa-catalog-card-tags">{p.role.slice(0, 2).map((r) => <span className="pa-catalog-tag" key={r}>{roleLabel(r)}</span>)}</div>
          </div>
        ))}
      </div>
      {filtered.length === 0 && <div className="pa-nav-empty" style={{ padding: 40, textAlign: 'center' }}>No dashboards match these filters.</div>}
    </>
  );
}
